<template>
  <div class="product-container">
    <div class="title-box">
      <div class="title-left">
        <div class="sign"></div>
        <span>{{ title || "机场预警" }}</span>
      </div>
      <div class="title-right">
        <div class="search-item">
          <van-icon name="search" />
          <input
            class="ipt-search"
            type="text"
            v-model="search"
            placeholder="请输入搜索关键词"
          />
        </div>
        <img :src="reSetSrc" @click="reSet()" />
      </div>
    </div>
    <div class="head-box">
      <van-field
        class="up-date-choose"
        readonly
        clickable
        name="datetime"
        :value="startDate"
        placeholder="点击选择时间"
        :right-icon="iconName"
        @click="showPiker('0')"
      />
      <div class="up-date-fh">至</div>
      <van-field
        class="up-date-choose"
        readonly
        clickable
        name="datetime"
        :value="endDate"
        placeholder="点击选择时间"
        :right-icon="iconName"
        @click="showPiker('1')"
      />
      <van-popup v-model="show" position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          type="datetime"
          :min-date="minDate"
          :max-date="maxDate"
          @cancel="show = false"
          @confirm="onConfirm"
          item-height="40"
          visible-item-count="3"
        />
      </van-popup>
    </div>
    <div class="body-box">
      <div class="list-head">
        <span>机场名称</span>
        <span>产品名称</span>
        <span>发布日期</span>
      </div>
      <div class="list-body">
        <van-pull-refresh
          v-model="refreshing"
          @refresh="onRefresh"
          :disabled="unRefresh"
        >
          <van-list
            v-model="loading"
            :error.sync="error"
            :error-text="errorTxt"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            :offset="200"
            @scroll.native="handleScroll($event)"
          >
            <div
              v-for="(item, i) in modelList[model - 1]"
              :key="i"
              :class="{ 'al-row': true, 'cell-bg-color': i % 2 < 1 }"
            >
              <div class="al-col-name">
                <span>{{ item.airport }}</span>
              </div>
              <div class="al-col-path" @click="openDetail(item, false)">
                <span>{{ item.title }}</span>
              </div>
              <div class="al-col-time">{{ item.time }}</div>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from "vant";
import refresh from "@/mixins/listRefresh";
export default {
  name: "product",
  mixins: [refresh],
  data() {
    return {
      model: 0,
      modelList: [[], [], []],
      totalCount: 0,
      show: false,
      reSetSrc: require("../../assets/reset-un.png"),
      iconName: require("../../assets/Thedateof.png"),
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      refreshing: false,
      error: false,
      errorTxt: "请求失败，点击重新加载",
      finished: false,
      loading: false,
      search: "",
      status: false, //节流函数判断依据
      docShow: false,
      currPick: "",
      title: "",
      currentDate: new Date(),
      startDate: "", //this.$btools.fuc.formatDate(new Date(), "yyyy-MM-dd hh:mm"),
      endDate: "", //this.$btools.fuc.formatDate(new Date(), "yyyy-MM-dd hh:mm"),
      page: 1,
      airportList: [
        "",
        "阿克苏机场",
        "阿勒泰机场",
        "且末机场",
        "富蕴机场",
        "库车机场",
        "库尔勒机场",
        "克拉玛依机场",
        "喀什机场",
        "塔城机场",
        "和田机场",
        "伊宁机场",
        "哈密机场",
        "那拉提机场",
        "喀纳斯机场",
        "莎车机场",
        "若羌机场",
        "吐鲁番机场",
        "博乐机场"
      ],
      datalist: []
    };
  },
  components: {
    [ImagePreview.Component.name]: ImagePreview.Component
  },
  methods: {
    initStartEndDate() {
      const dates = this.$btools.date.getDate("fewDays", 3);
      // eslint-disable-next-line no-useless-escape
      const sarr = this.$btools.fuc.formatDate(dates.startTime, "yyyy/MM/dd hh:mm").split(/[- : \/]/), earr = this.$btools.fuc.formatDate(new Date(), "yyyy/MM/dd hh:mm").split(/[- : \/]/);
      const sdate = new Date(sarr[0], sarr[1] - 1, sarr[2], sarr[3], sarr[4]);
      const edate = new Date(earr[0], earr[1] - 1, earr[2], earr[3], earr[4]);
      this.startDate = this.$btools.fuc.formatDate(sdate, "yyyy-MM-dd hh:mm");
      this.endDate = this.$btools.fuc.formatDate(edate, "yyyy-MM-dd hh:mm");
      console.log("endDate", this.endDate);
    },
    onConfirm() {
      let _date = this.$btools.fuc.formatDate(
        this.currentDate,
        "yyyy-MM-dd hh:mm"
      );
      if (this.currPick === "0") {
        this.startDate = _date;
      } else {
        this.endDate = _date;
      }
      console.log("this.startDate, this.endDate", this.startDate, this.endDate);
      this.show = false;
    },
    reSet() {
      const that = this;
      that.reSetSrc = require("../../assets/reset-act.png");
      that.startDate = this.$btools.fuc.formatDate(
        new Date(),
        "yyyy-MM-dd hh:mm"
      );
      that.endDate = this.$btools.fuc.formatDate(
        new Date(),
        "yyyy-MM-dd hh:mm"
      );
      that.$toast("查询时间已重置！");
      setTimeout(function() {
        that.reSetSrc = require("../../assets/reset-un.png");
      }, 200);
    },
    showPiker(key) {
      this.currPick = key;
      this.show = true;
    },
    onLoad() {
      const that = this;
      setTimeout(() => {
        if (that.refreshing) {
          that.refreshing = false;
        }
        that.getData(res => {
          if (res && "all" in res) {
            if (that.page === 1) {
              that.datalist = [];
              that.modelList = [[], [], []];
            }
            that.totalCount = res["all"];
            that.realData(res);
            const { list = [] } = res;
            if (that.datalist.length >= that.totalCount || list.length <= 0) {
              that.finished = true;
            } else {
              that.page += 1;
            }
          } else {
            that.getListError("请求失败!");
          }
        });
      }, 300);
    },
    onRefresh() {
      this.page = 1;
      // 清空列表数据
      this.finished = false;
      this.error = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    getData(func) {
      let param = {
        keyWord: this.search,
        forecast: 1,
        airport: 1,
        weather: 1,
        page: this.page,
        pageSize: 10,
        beginTime: this.startDate + ":00",
        endTime: this.endDate + ":00"
      };
      let that = this;
      this.$http({
        url: "/forecastMake/product/getProduct",
        method: "post",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        data: JSON.stringify(param)
      })
        .then(r => {
          console.log("机场预警（产品共享）源数据：", r);
          that.loading = false;
          if (typeof func === "function") {
            func(r["data"]);
          }
        })
        .catch(e => {
          that.getListError("请求失败!");
          console.log("获取产品信息异常：" + e);
        });
    },
    getListStart() {
      this.page = 1;
      this.loading = true;
      this.finished = false;
      this.onLoad();
    },
    getListError(text) {
      this.refreshing = false;
      this.datalist = [];
      this.modelList = [[], [], []];
      this.loading = false;
      this.error = true;
      this.errorTxt = text;
    },
    realData(o) {
      console.log("开始数据处理...");
      try {
        if (o && o["list"]) {
          for (let i = 0; i < o["list"].length; i++) {
            if (Object.keys(o["list"][i]).length <= 1) {
              continue;
            }
            let arr = o["list"][i].airportid.split(",");
            let _arr = [];
            for (let x = 0; x < arr.length; x++) {
              _arr.push(this.airportList[arr[x]]);
            }
            const tempModel = parseInt(o["list"][i].MODULE || "0", 10);
            let _path =
              (tempModel === 3
                ? "http://172.17.28.1:50001/forecastMake/"
                : "http://172.17.28.1:50001/alarmProduction/") +
              o["list"][i].FILEPATH;
            //_path = _path.replace(/172.17.28.1/g, "124.117.223.3");
            const listItem = {
              airport: _arr.join(","),
              time: o["list"][i].newTime,
              fpath: _path,
              //fpath: "http://view.xdocin.com/xdoc?_xdoc=" + _path,
              //fpath:'http://view.xdocin.com/xdoc?_xdoc=http://www.unusualus.com/20200517171548936.doc',
              title: o["list"][i].newtitle
            };
            this.datalist.push(listItem);
            if (tempModel !== 0 && this.model === tempModel) {
              this.modelList[this.model - 1].push(listItem);
            }
          }
          console.log("处理前的数据：", o);
          console.log("处理后的总数据：", this.datalist);
          console.log("处理后的过滤数据：", this.modelList[this.model - 1]);
        } else {
          this.getListError("数据异常，点击尝试重新获取！");
        }
      } catch (e) {
        console.log("处理数据异常：", e);
      }
    },
    hideTranslate(e) {
      if (e.target.className !== "wrapper") {
        return;
      }
      this.docShow = false;
    },
    makeTestData() {
      let _data = {
        all: 20, //总条数
        list: []
      };
      for (let i = 0; i < 20; i++) {
        _data.list.push({
          CONTENTID: 106,
          FILEPATH: "/ProductsFile/2020/05/12/20200512175321556.doc",
          IssueDateTime1: null,
          IssueDateTime2: 1589276940000,
          IssueNum1: null,
          IssueNum2: "58",
          MODULE: 2, //模块
          PRODUCTNAME: "2020年05月12日17时49分冰雹或冻雨.doc",
          Title1: null,
          Title2: "莎车机场、若羌机场冰雹或冻雨橙色预警",
          Title3: null,
          airport1: null,
          airport2: "15,16",
          airportid: "15,16,17,18",
          newTime: "2020-05-12 17:49:00",
          newtitle: "莎车机场、若羌机场冰雹或冻雨橙色预警",
          publishNum: "58",
          publishTime: null
        });
      }
      this.realData(_data);
    },
    openDetail(m, isXdoc) {
      if (!isXdoc) {
        let param = {
          user: this.$store.state.api_user,
          password: this.$store.state.api_password,
          version: 3,
          funname: "project/xinjiangaviation/forecastdata/GetPhotoByWordUrl",
          funversion: 1,
          url: m.fpath
        };
        const _url = "/Services?" + this.$qstring.stringify(param);
        ImagePreview({
          images: [_url],
          closeable: true
        });
      }
    },
    //节流函数
    throttle() {
      //保持this的指向始终指向vue实例
      const that = this;
      if (!that.status) {
        return;
      }
      that.status = false;
      try {
        let interID = setTimeout(function() {
          console.log("定时器执行!");
          that.getListStart();
          that.status = true;
        }, 1000);
        console.log("成功设置定时器，id:", interID);
      } catch (e) {
        console.log("设置定时器失败，error:", e);
      }
    }
  },
  computed: {
    allInit: function() {
      return this.datalist.length >= this.totalCount;
    },
    changepage: function() {
      return this.startDate + this.endDate;
    },
    changeSearch: function() {
      return this.search;
    }
  },
  watch: {
    "$route.query.moudel": {
      handler(v) {
        this.model = parseInt(v, 10);
        this.getListStart();
      },
      immediate: true
    },
    /*allInit(v){
      console.log('allInit', v)
      if(v && this.totalCount!==0){
        this.onLoad()
      }
    },*/
    changepage: function() {
      this.getListStart();
    },
    changeSearch: function() {
      this.status = true;
      this.page = 1;
      this.throttle();
    }
  },
  mounted() {
    this.initStartEndDate();
    //this.makeTestData();
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/index";
.product-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0);
  margin: 0 auto;
  .title-box {
    display: flex;
    flex-direction: row;
    height: 8%;
    //height: px2rem(58);
    width: 95%;
    .title-left {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      height: 100%;
      width: 32.5%;
      .sign {
        width: 3px;
        height: px2rem(16);
        background-image: linear-gradient(180deg, #fe5936 0%, #fca656 100%);
      }
      span {
        font-size: px2rem(18);
        color: #ffffff;
        margin-left: px2rem(4);
      }
    }
    .title-right {
      height: 100%;
      width: 67.5%;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
      .search-item {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        height: px2rem(29);
        width: px2rem(186);
        background-image: linear-gradient(142deg, #2b2f34 0%, #2b2f33 100%);
        box-shadow: inset 0 3px 6px 0 rgba(0, 0, 0, 0.24),
          inset 0px -2px 2px 0px rgba(255, 255, 255, 0.09);
        border-radius: px2rem(12);
        .van-icon.van-icon-search {
          margin-left: px2rem(10);
          height: px2rem(15);
          width: px2rem(15);
          color: rgba(255, 255, 255, 0.7);
        }
        .ipt-search {
          width: px2rem(120);
          height: 100%;
          font-size: px2rem(14);
          background-color: rgba(0, 0, 0, 0);
          color: #fefefe;
          border: 0;
        }
      }
      img {
        height: px2rem(30);
        width: px2rem(30);
      }
      & > :first-child {
        margin-right: px2rem(20);
      }
    }
    /*border: 1px solid violet;*/
  }
  .head-box {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    //height: px2rem(45);
    height: 8%;
    width: 95%;
    .up-date-choose {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      width: px2rem(160);
      height: px2rem(44);
      box-sizing: border-box;
      background-image: linear-gradient(142deg, #2b2f34 0%, #2b2f33 100%);
      box-shadow: inset 0 3px 6px 0 rgba(0, 0, 0, 0.24),
        inset 0px -2px 2px 0px rgba(255, 255, 255, 0.09);
      border-radius: px2rem(12);
      padding: 0 px2rem(8);
      span {
        font-size: px2rem(14);
        color: #a0a2a4;
      }
    }
    /deep/.van-icon img {
      color: #fefefe;
      margin-left: px2rem(10);
      height: px2rem(16);
      width: px2rem(14);
    }
    /deep/.van-field__control {
      font-size: px2rem(14);
      color: #a0a2a4;
    }
    /deep/.van-field__right-icon {
      margin-right: 0;
      padding: 0;
    }
    /deep/.van-cell::after {
      border-bottom: 0;
    }
    .up-date-fh {
      width: px2rem(30);
      text-align: center;
      color: #bfbfbf;
      font-size: px2rem(12);
    }
    /*border: 1px solid greenyellow;*/
  }
  .body-box {
    height: 82%;
    width: 95%;
    //margin-top: px2rem(12);
    margin-top: 2%;
    background-image: linear-gradient(180deg, #32383e 0%, #2d3134 100%);
    box-shadow: -2px 3px 3px 0px #212121;
    border-radius: 6px;
    .list-head {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      background-color: #212428;
      height: 8%;
      //height: px2rem(39);
      span {
        font-size: px2rem(14);
        letter-spacing: 0;
        color: #e02c00;
      }
      /*border: 1px solid red;*/
    }
    .list-body {
      height: 92%;
      overflow: hidden;
      .van-pull-refresh {
        height: 100%;
        .van-list {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;
          height: 99%;
          width: 100%;
          overflow-y: scroll;
          .al-row {
            display: flex;
            flex-direction: row;
            // height: px2rem(60);
            width: 100%;
            flex-shrink: 0;
            color: rgb(216, 216, 216);
            span {
              padding: px2rem(10);
              width: 100%;
              line-height: px2rem(20);
              font-size: px2rem(14);
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .al-col-name {
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              white-space: nowrap;
              width: 30%;
            }
            .al-col-time {
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              width: 25%;
              height: 100%;
            }
            .al-col-path {
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              width: 45%;
              height: 100%;
            }
          }
          .cell-bg-color {
            background-color: #24272c;
          }
        }
      }
    }
    /*border: 1px solid blue;*/
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .alarm-block {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      width: 80%;
      height: 80%;
      border-radius: 10px;
      background-color: #fff;
      overflow: hidden;
      overflow-y: scroll;
      iframe {
        height: 100%;
      }
    }
  }
}
</style>
